import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SEO } from './components/SEO'
import { MichelaLanding } from './components/MichelaLanding'
import { PrivacyPolicy } from './components/PrivacyPolicy'
import { TermsOfService } from './components/TermsOfService'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <SEO
                title="Michela — Your Personal Stylist"
                description="Tell us the plan. Get three outfits you'll actually wear. Personal styling from your own wardrobe."
                image="/og-image.png"
                url={import.meta.env.VITE_APP_URL || 'https://michela.app'}
              />
              <MichelaLanding />
            </>
          }
        />
        <Route
          path="/privacy"
          element={
            <>
              <SEO
                title="Privacy Policy — Michela"
                description="Learn how Michela collects, uses, and protects your personal information."
                image="/og-image.png"
                url={`${import.meta.env.VITE_APP_URL || 'https://michela.app'}/privacy`}
              />
              <PrivacyPolicy />
            </>
          }
        />
        <Route
          path="/terms"
          element={
            <>
              <SEO
                title="Terms of Service — Michela"
                description="Read the terms and conditions for using Michela's personal styling service."
                image="/og-image.png"
                url={`${import.meta.env.VITE_APP_URL || 'https://michela.app'}/terms`}
              />
              <TermsOfService />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
